(function () {
    'use strict';

    function requestForProposalResponseEditorController($scope, $timeout, $state, $uibModal, $window,
        notifyService, requestForProposalResponseStateService, requestForProposalResponseDataService, sessionData, milestones,
        mailRequestDataService, milestoneModalService) {

        var vm = this;
        vm.rfpResponseData = requestForProposalResponseStateService.get();
        vm.rfpResponseId = vm.rfpResponseData.Id.split('/')[1];
        vm.sessionData = sessionData;

        vm.rfpResponseData.hasPermissionsSet = true;
        vm.rfpResponseData.ResponseContent.InformationParts.forEach(function (informationPart) {
            informationPart.canDelete = false;
            informationPart.reorderMode = false;
            informationPart.Access = {
                View: true,
                Edit: false
            }
        });

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.contactRespondent = function (entity) {
            notifyService.notify('We sent a notification to ' + entity.CompanyDetails.Name);
        }

        vm.rfpEntityActions = {
            contactRespondent: {
                label: "Contact",
                call: vm.contactRespondent
            }
        }

        vm.updateRfpResponse = function (submit) {
            vm.rfpResponseData.ResponseStatus = submit ? 'ApplicationSubmitted' : 'ApplicationInProgress';
            if (!vm.rfpResponseData.HasBeenSubmitted) {
                vm.rfpResponseData.HasBeenSubmitted = true;
            }

            requestForProposalResponseStateService.update(vm.rfpResponseData);

            if (submit) {
                mailRequestDataService.sendRequestForProposalResponseUpdate({
                    RequestForProposalId: vm.rfpResponseData.RequestForProposalId,
                    RequestForProposalResponseId: vm.rfpResponseData.Id,
                    EntityId: vm.sessionData.EntityId,
                    RecordedActivity: {
                        Date: (new Date()).toISOString(),
                        Description: 'The response status was changed to \'Application Submitted\'',
                        UsersToNotify: [],
                        UserName: vm.sessionData.EntityId
                    }
                });

                notifyService.notify(
                    'Your response has been submitted. You are being redirected to your activities. <a style="text-decoration: underline" href="/entities/home/activities">Click here</a> to go there now.');

                $timeout(function() {
                        $window.location = '/entities/home/activities';
                    },
                    3000);
            }
            else {
                notifyService.notify('Your response has been updated.');
            }
        }

        vm.openDeleteAlert = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'deleteRequestForProposalResponseModal',
                controller: 'deleteRequestForProposalResponseModalController',
                resolve: {
                    rfpResponseId: function () {
                        return vm.rfpResponseData.Id;
                    },
                    entityName: function () { return ''; }
                }
            });

            return modalInstance.result.then(function (wasDeleted) {
                if (wasDeleted) {
                    $window.location = '/dashboard';
                }
            });
        }

        $scope.$on('fileUploaded', function (event, args) {
            var documentObject = vm.rfpResponseData.ResponseContent.InformationParts.find(function (informationPart) {
                return args.parent.Title === informationPart.Title;
            });

            if (!documentObject.BlobSummaries) {
                documentObject.BlobSummaries = [];
            }

            documentObject.BlobSummaries = documentObject.BlobSummaries.concat(args.blobs);
            requestForProposalResponseStateService.update(vm.rfpResponseData);
            notifyService.notify('You uploaded ' + args.blobs[0].FileName);
        });

        $scope.$on('rfpResponseUpdated', function () {
            vm.rfpResponseData = requestForProposalResponseStateService.get();
        });
    }

    requestForProposalResponseEditorController.$inject = ['$scope', '$timeout', '$state', '$uibModal', '$window',
        'notifyService', 'requestForProposalResponseStateService', 'requestForProposalResponseDataService', 'sessionData', 'milestones',
        'mailRequestDataService', 'milestoneModalService'];

    angular.module('ecap.requestForProposal').controller('requestForProposalResponseEditorController', requestForProposalResponseEditorController);
})();
